export default class UnexpectedLoginResponseError extends Error {
  constructor() {
    super('Ocorreu um erro, tente novamente.');
    this.name = 'UnexpectedLoginResponseError';
  }
}
